import React from 'react';

import noResultsImage from '../../images/no-results-magnifying-glass.svg';
import {
  GoogleAutocompleteNoSearchResultsTitle,
  GoogleAutocompleteNoResultsWrapper,
} from './styles';

export const GoogleAutocompleteNoResults = ({
  children,
  image = noResultsImage,
  imageAlt = 'no search results',
  title = 'Can’t find your business?',
}) => (
  <GoogleAutocompleteNoResultsWrapper>
    {image && <img src={image} alt={imageAlt} />}

    {title && (
      <GoogleAutocompleteNoSearchResultsTitle>
        {title}
      </GoogleAutocompleteNoSearchResultsTitle>
    )}

    {children}
  </GoogleAutocompleteNoResultsWrapper>
);
